import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Icons from './icons.svg';
import './CustomIcon.scss';

export const CustomIcon = ({ icon, color = 'black', size = 24, className }) => (
  <svg
    className={classNames('svg-icon', className)}
    style={{ width: `${size}px`, height: `${size}px` }}
    fill={color}
  >
    <use href={`${Icons}#${icon}`} />
  </svg>
);

CustomIcon.propTypes = {
  icon: PropTypes.string.isRequired,
  color: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string
};
